import { ApiError } from "@/api/client";
import { AiNote } from "@/components/AiNote";
import { ModalShell } from "@/components/ui";
import { t } from "@/i18n";

import type { AiAnalyzeResponse } from "./aiAnaliz";

interface AiAnalizModalProps {
  open: boolean;
  isLoading: boolean;
  error: unknown;
  data: AiAnalyzeResponse | undefined;
  onClose: () => void;
  onFollowUp?: (question: string) => void;
}

function hataMesaji(error: unknown): string {
  if (error instanceof ApiError) {
    if (typeof error.detail === "string") return error.detail;
    return error.message;
  }
  return t("common.error");
}

/**
 * Yorumlar sayfasina ozel, basit AI analiz modali (gorev talimati: paylasilan
 * bir Modal bileseni YOK, features/yorumlar altinda kendi govdesi — ama
 * govde artik paylasilan `ModalShell` kabugunu kullanir, sadece icerik
 * yorumlara ozel kalir). Markdown render'i paylasilan AiNote/lib/markdown.ts
 * uzerinden.
 */
export function AiAnalizModal({ open, isLoading, error, data, onClose, onFollowUp }: AiAnalizModalProps) {
  if (!open) return null;

  return (
    <ModalShell open title={t("yorumlar.ai.baslik")} onClose={onClose} size="md">
      {isLoading && <p className="text-sm text-muted">{t("yorumlar.ai.yukleniyor")}</p>}
      {!isLoading && error != null && (
        <p role="alert" className="text-sm text-red">
          {hataMesaji(error)}
        </p>
      )}
      {!isLoading && error == null && data && (
        <AiNote markdown={data.response.answer_markdown} followUps={data.response.follow_up_prompts ?? []} onFollowUp={onFollowUp} />
      )}
    </ModalShell>
  );
}
